<template>
  <div class="subSuccess">
    <div class="suc-content">
      <div class="sub-icon"></div>
      <div class="wordW20" style="margin-top:16px;">
        {{$t('kycFile.subSuccess.success')}}
      </div>
      <div class="wordB14" style="margin-top:20px;margin-bottom:40px;">
        {{$t('kycFile.subSuccess.tip')}}
      </div>
      <lls-button type="primary" @click="toIndex">
        {{$t('kycFile.subSuccess.btnText')}}
      </lls-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toIndex() {
      this.$router.push({path: '/main-productCenter'});
    },
  },
};
</script>
<style lang="scss" scoped>
.subSuccess {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .suc-content {
    width: 500px;
    height: 300px;
    text-align: center;
    .sub-icon {
      width: 44px;
      height: 44px;
      background: url("~@/static/kjaccSonImg/sucIcon.png") center center
        no-repeat;
      margin: 0 auto;
    }
  }
}
</style>